<template>
  <div class="screen screen__training" v-loading="!trainingLanding">

    <page-banner :heading="trainingLanding.title" :sub-heading="trainingLanding.subheading"></page-banner>

    <el-container direction="horizontal" class="page--container">
      <el-row :gutter="30">
        <el-col>

          <section class="page--section">
            <el-row :gutter="60">
              <el-col :md="{ span: 20, offset: 2 }">
                <div v-html="trainingLanding.overview" class="headings-dark"></div>
              </el-col>
            </el-row>
          </section>

          <training-statistics-bar :certificates="certificatesCount" :completed="completedCoursesCount"
            :inProgress="inProgressCourses.length" :courses="courseCatalog.length">
          </training-statistics-bar>

          <training-in-progress v-if="inProgressCourses.length" :courseCatalog="courseCatalog"
            :usersCourses="inProgressCourses">
          </training-in-progress>

          <training-available v-if="availableCourses.length" :availableCourses="availableCourses"
            :usersCourses="usersCourses">
          </training-available>

          <training-full-lines v-if="fullLineCertifications.length" :certifications="fullLineCertifications"
            :courseCatalog="courseCatalog">
          </training-full-lines>

          <training-on-demand :heading="trainingLanding.featuredVideoHeading" :videos="trainingLanding.featuredVideos">
          </training-on-demand>

          <training-webinar-listing v-if="webinars.length" :webinars="webinars">
          </training-webinar-listing>
        </el-col>
      </el-row>
    </el-container>
    <footer-main />
  </div>
</template>

<script>
import api from '@/api';
import PageBanner from '@/components/PageBanner.vue';
import training from '@/components/training';
import TrainingAvailable from '@/components/training/TrainingAvailable.vue';
import TrainingInProgress from '@/components/training/TrainingInProgress.vue';
import TrainingStatisticsBar from '@/components/training/TrainingStatisticsBar.vue';
import TrainingFullLines from '@/components/training/TrainingFullLines.vue';
import TrainingOnDemand from '@/components/training/TrainingOnDemand.vue';
import TrainingWebinarListing from '@/components/training/TrainingWebinarListing.vue';
import FooterMain from '@/components/footer/FooterMain.vue';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'Training',
  computed: {
    ...mapState(training.store.namespace, [
      'availableCourses',
      'completedCoursesCount',
      'certificatesCount',
      'courseCatalog',
      'inProgressCourses',
      'fullLineCertifications',
      'trainingLanding',
      'usersCourses',
      'webinars',
    ]),
  },
  components: {
    PageBanner,
    TrainingAvailable,
    TrainingInProgress,
    TrainingStatisticsBar,
    TrainingOnDemand,
    TrainingFullLines,
    TrainingWebinarListing,
    FooterMain,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/base/_variables.scss';

.screen__training {
  .el-row {
    margin: 0 -20px;

    .el-col {
      padding: 0 14px;
      background-color: $--color-white;
    }
  }
}
</style>
